<template>
	<div class="home">
		<template v-for="module_item in module_list">
			<template v-if="module_item.item_type == 'slider'">
				<div class="banner">
					<div class="slider-banner">
						<swiper class="swiper-item" ref="mySwiper" :options="{...swiperOption, autoplay: { delay: module_item.data.internal * 1000, disableOnInteraction: false }}">
							<swiper-slide v-for="(item, index) in module_item.data.image_list" :key="index">
								<img :src="item.image" class="img" />
							</swiper-slide>
						</swiper>
					</div>
				</div>
			</template>
			<template v-if="module_item.item_type == 'image'">
				<div class="home-image-container">
					<div class="image-list"  :style="{'padding': module_item.style.padding + 'px'}">
						<div>
							<div v-for="(item, index) in module_item.data.image_list" :key="index" class="image-item" @click="image_redirect(item.url)" :class="{pointer: !!item.url}">
								<div  class="image"   :style="{'padding': module_item.style.item.padding + 'px', 'margin': module_item.style.item.margin + 'px'}">
									<img :src="item.image" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-if="module_item.item_type == 'rich'">
				<div v-html="module_item.data.html"></div>
			</template>
			<template v-if="module_item.item_type == 'mtm'">
				<div class="boutique-box">
					<div class="title">{{module_item.data.title}}</div>
					<div class="sub-title">{{module_item.data.summary}}</div>
					<div class="boutique-list" v-if="module_item.data.product_list.length > 0">

						<div class="item" v-for="(item, index) in module_item.data.product_list" :key="index" >
							<router-link  @click.native="pick(item)" :to="{ name: 'CategoryDetail', query: {id : item.product_id}}">
								<img :src="item.image_main" mode="widthFix" />
								<div class="name">{{ item.product_name }}</div>
								<div class="price">￥{{ item.price }}</div>
								<div class="design">立即定制</div>
							</router-link>
						</div>

					</div>
				</div>
			</template>
		</template>
		<!--<div class="banner">
			<div class="slider-banner">
				<swiper class="swiper-item" ref="mySwiper" :options="swiperOption">
					<swiper-slide v-for="(item, index) in banners" :key="index">
						<img :src="item.img" class="img" />
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<div class="service-box">
			<div class="title">我们的服务</div>
			<div class="sub_title">咨询服务</div>
			<div class="design-img">
				<div class="item service-img1">
					<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/1@2x.png" >
				</div>

				<router-link class="item service-img2" to="/group_category">
					<div class="design-name">团体订制</div>
					<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/2@2x.png"  style="margin-top: 28px;">
				</router-link>

				<router-link class="item service-img2" to="/categoryList">
					<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/3@2x.png" class="" style="margin-bottom: 28px;">
					<div class="design-name">精品定制</div>
				</router-link>
				<router-link class="item service-img2" to="/category">
					<div class="design-name">私人订制</div>
					<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/4@2x.png"  class="" style="margin-top: 28px;">
				</router-link>
			</div>
		</div>

		<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/1.png" class="design-box"></img>
		<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/2.png" class="subscribe-box"></img>

		&lt;!&ndash; <div class="subscribe">
			<div class="title">专业顾问 免费上门量体</div>
			<div class="sub_title">咨询预约</div>
			<div class="img-box">
				<img src="../assets/images/home/new-home/img7@2x.png" class="img7">
				<img src="../assets/images/home/new-home/img8@2x.png" class="img8">
				<div class="img9">
					<div class="subscribe-step">
						<div class="step-item">
							<div class="step-title">NO .1  在线设计  预约量体</div>
							<div class="step-sub-title">确定面料款式，在线预约量体</div>
							<div class="step-sub-title">电话确认上门时间</div>
						</div>
						<div class="step-item">
							<div class="step-title">NO .2  专业量体  免费上门</div>
							<div class="step-sub-title">专业着装顾问，免费上门量体</div>
							<div class="step-sub-title">采集26个身材数据</div>

						</div><div class="step-item">
							<div class="step-title">NO .3  专业剪裁  精心制作 </div>
							<div class="step-sub-title">298道工序，专业裁剪精心缝制</div>
							<div class="step-sub-title">全方位专业整烫</div>

						</div><div class="step-item">
							<div class="step-title">NO .4  交付成衣  售后无忧</div>
							<div class="step-sub-title">10个工作日交付成衣，365天</div>
							<div class="step-sub-title">售后保障</div>
						</div>
					</div>
				</div>

			</div>
		</div> &ndash;&gt;


		<div class="boutique-box">
			<div class="title">精品展示</div>
			<div class="sub-title">BOUTIQUE DISPLAY</div>
			<div class="boutique-list" v-if="products.length > 0">

				<div class="item" v-for="(item, index) in products" :key="index" >
					<router-link  @click.native="pick(item)" :to="{ name: 'CategoryDetail', query: {id : item.id}}">
						<img :src="item.main_image" mode="widthFix" />
						<div class="name">{{ item.category_name_cn }}</div>
						<div class="price">￥{{ item.price }}</div>
						<div class="design">立即定制</div>
					</router-link>
				</div>

			</div>
		</div>
		<div class="static-img">
			<img src="https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/img14@2x.png" />
		</div>-->

	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper'
	import {
		getContentList,
		MTemplate,
		getHomeDeco
	} from "@/api"
	export default {
		name: 'Home',
		components: {
			swiper,
			swiperSlide
		},
		created() {
			this.getTemplateList()
		},
		computed: {

		},
		methods: {
			async getNewsList() {
				let json = await getContentList({
					page: 1,
					size: 3
				})
				this.contentList = json.data.list
			},
			go2article(article) {
				if (article.show_type == 9) {
					window.open(article.external_link)
				} else {
					this.$router.push({
						path: '/detail',
						query: {
							id: article.content_id
						}
					})
				}
			},
			more() {
				this.$router.push({
					path: '/news'
				})
			},
			pick(value) {

				this.$store.commit('mtm/pick', {category:value})
			},
			async getTemplateList() {
				return await MTemplate({category_id:0,is_standard_mtm:1}).then((response) => {
					this.products = response.data
					if(this.products.length > 4) {
						this.products = this.products.splice(0,4)
					}

				})
			},
			init() {
				getHomeDeco({}).then(response => {
					this.module_list = response.data.module_list
				})
			},
			image_redirect(url) {
				if(url.includes('http')) {
					window.location.href = url
				} else {
					this.$router.push(url)
				}
			}
		},
		data() {
			return {
				swiperOption: {
					// navigation: {
					// 	nextEl: '.swiper-button-next',
					// 	prevEl: '.swiper-button-prev'
					// }
				},
				banners: [{
						img: 'https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/banner@2x.png'
					}
				],
				products: [],
				module_list: []
			}
		},
		mounted() {
			this.init();
			this.$emit("showLogin", true);
			this.$emit("showBack", false);
			this.$emit("showNav", true);
			this.$emit("showFooter", true);
		}
	}
</script>

<style lang="scss" scoped>
	.home {
		width: 100%;

	}

	.banner {
		max-height: 802px;
		overflow: hidden;
	}
	.home-image-container {
		.image-list>div { display: flex; width: 100%; }
		.image-list>div>.image-item { flex: 1; text-align: center;}
		.image-list {
			.image-item {
				&.pointer {
					cursor: pointer;
				}
			}
		}
	}

	.service-box{
		width: 100%;
		// height: 800px;
		padding-bottom: 50px;
		.title {
			font-size: 50px;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #000000;
			width: 100%;
			text-align: center;
			margin-top: 50px;
		}
		.sub_title{
			width: 186px;
			height: 48px;
			line-height: 48px;
			text-align: center;
			background: #1C1E2B;
			font-size: 21px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			margin: 10px auto;
		}
		.design-img{
			margin: auto;
			padding-top: 30px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 75%;
			.item{
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				.design-name{
					width: 100%;
					height: 130px;
					background: #F7F7F7;
					font-size: 22px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #363636;
					line-height: 130px;
					text-align: center;
				}

			}
			.service-img1{
				width: 30%;
			}
			.service-img2{
				width: 20%;
			}


		}
	}
	.design-box{
		width: 100%;
	}
	.subscribe-box{
		width: 100%;

	}
	.subscribe{
		.title {
			font-size: 50px;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #000000;
			width: 100%;
			text-align: center;
			margin-top: 50px;
			letter-spacing: 10px;
		}
		.sub_title{
			width: 170px;
			height: 43px;
			line-height:43px;
			text-align: center;
			background: #1C1E2B;
			font-size: 21px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			margin: 10px auto;
		}
		.img-box{
			width: 75%;
			margin: auto;
			padding-top: 30px;
			position: relative;
			display: flex;
			justify-content: space-between;
			.img7{
				width:43%;
				z-index: 1;
			}
			.img8{
				width: 43%;
				z-index: 1;
			}
			.img9{
				background-image: url(https://chinasite.oss-cn-shenzhen.aliyuncs.com/pc/new-home/img9@2x.png);
				background-size: 100%;
				position: absolute;
				top: 105px;
				left: 15%;
				width: 66%;
				height: 664.55px;
				z-index: 2;
				.subscribe-step{
					position: absolute;
					top: 50px;
					left: 473px;
					.step-item{
						margin-bottom: 50px;
						.step-title{
							font-size: 25px;
							font-family: PingFang SC-Bold, PingFang SC;
							font-weight: bold;
							color: #000000;
							line-height: 50px;
						}
						.step-sub-title{
							font-size: 16px;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #646262;
							line-height: 28px;
						}
					}
				}


			}
		}

	}

	.boutique-box{
		text-align: center;
		margin: 50px 0;
		.title{
			font-size: 38px;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #000000;
		}
		.sub-title{
			font-size: 18px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
		}
		.boutique-list{
			width: 75%;
			padding-top: 20px;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.item{
				width: 24%;
				text-align: center;
				.name{
					font-size: 16px;
					font-family: PingFang SC-Bold, PingFang SC;
					font-weight: bold;
					color: #333333;
					margin-top: 10px;
				}
				.price{
					font-size: 18px;
					font-family: PingFang SC-Bold, PingFang SC;
					font-weight: bold;
					color: #0F114A;
					margin-top: 5px;
				}
				.design{
					width: 120px;
					height: 43px;
					line-height: 43px;
					background: #0F114A;
					color: #FFFFFF;
					text-align: center;
					font-size: 16px;
					font-family: PingFang SC-Bold, PingFang SC;
					font-weight: bold;
					margin: 5px auto;
				}

			}
		}
	}



</style>
